import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as liveCallAPI from 'api/liveCall';
import * as liveCallTranscriptAPI from 'api/liveCallTranscript';
import { CALL_STATUS } from 'utils/common';
import { generateTranscriptionFromAPI, isEmpty } from 'utils/redux';
const initialState = {
  pagination: {
    pageSize: 10,
    currentPage: 1,
    totalRecords: null,
    index: 1
  },
  live_count: null,
  data: [],
  showchat: false,
  ui: {
    loading: false,
    msg: ''
  },
  status: 'idle',
  selected: {
    id: null,
    index: null,
    number: null
  },
  transcript: {}
};
const getLiveCallstate = (state) => state.liveCall;

const getLiveCallsData = createAsyncThunk('liveCall/getliveCall', async ({ url, signal }) => {
  const res = await liveCallAPI.getAllLiveCall({ url, signal });
  return res.data?.data;
});

const livecalltranscript = createAsyncThunk('liveCall/getlivecalltranscript', async (id) => {
  const res = await liveCallTranscriptAPI.gettranscript(id);
  console.log(res, '0000000000');
  return { data: res.data?.data, uuid: id };
});

const liveCallSlice = createSlice({
  name: 'liveCall',
  initialState: initialState,

  reducers: {
    resetState: () => {
      return initialState;
    },
    setPageSize: (state, action) => {
      state.pagination.pageSize = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.pagination.currentPage = action.payload;
    },
    addLiveCall: (state, { payload }) => {
      if (payload) {
        state.data.push(payload);
      }
    },
    showchat: (state, action) => {
      console.log(action.payload, 'actioncheck');
      state.showchat = action.payload;
    },
    setSelectedId: (state, action) => {
      console.log(action.payload, 'actionratherthen');
      const { index, id, number } = action.payload;

      state.selected.id = id;
      state.selected.number = number;
      if (index > state.pagination.pageSize - 1) {
        state.pagination.index = state.pagination.index + 1;
        state.selected.index = 0;
      } else if (index < 0) {
        state.pagination.index = state.pagination.index - 1;
        state.selected.index = state.pagination.pageSize - 1;
      } else {
        state.selected.index = index;
      }
    },

    updateLiveCall: (state, { payload }) => {
      if (payload) {
        console.log('updateLiveCall', payload);
        const data = payload;
        console.log('updateLiveCall data.call_uuid', data.call_uuid);
        const indexOfCalls = state.data.findIndex((call) => call?.data?.call_uuid === data.call_uuid);
        console.log('updateLiveCall indexOfCalls', indexOfCalls);

        if (indexOfCalls > -1) {
          if (data.call_status === CALL_STATUS.Ended) {
            state.data.splice(indexOfCalls, 1);
            if (Object.prototype.hasOwnProperty.call(state.transcript, data.call_uuid)) {
              delete state.transcript[data.call_uuid];
            }
          } else {
            state.data[indexOfCalls] = { data, ...data };
          }
        } else {
          if (!(data.call_status === CALL_STATUS.Ended)) {
            state.data.push({ data, ...data });
          }
        }
      } else {
        console.error('updateLiveCall');
      }
    },
    updateLiveCallIntent: (state, { payload }) => {
      if (payload) {
        const { intent, call_id } = payload.data;
        const indexOfCalls = state.data.findIndex((call) => call.data.call_uuid === call_id);
        if (indexOfCalls > -1) {
          state.data[indexOfCalls] = {
            ...state.data[indexOfCalls],
            avg_intent: intent ? intent : state.data[indexOfCalls].avg_intent
          };
        }
      }
    },
    updateLiveCallTranscription: (state, { payload }) => {
      if (payload) {
        console.log('updateLiveCallTranscription', payload);
        const { message, uuid, callContentID } = payload;
        console.log('updateLiveCallTranscription data.call_uuid', message, uuid);
        message.id = callContentID;
        const indexOfCalls = state.data.findIndex((call) => call?.data?.call_uuid === uuid);
        if (indexOfCalls > -1) {
          state.data[indexOfCalls] = {
            ...state.data[indexOfCalls],
            avg_sentiment: message.avg_sentiment ? message.avg_sentiment : state.data[indexOfCalls].avg_sentiment,
            avg_intent: message.avg_intent ? message.avg_intent : state.data[indexOfCalls].avg_intent
          };
        }
        if (Object.prototype.hasOwnProperty.call(state.transcript, uuid)) {
          state.transcript[uuid].push(message);
        } else {
          state.transcript[uuid] = [message];
        }
      } else {
        console.error('error updateLiveCallTranscription');
      }
    },
    updateLiveCallTranscriptionIntentOrSentiment: (state, { payload }) => {
      if (payload) {
        console.log('updateLiveCallTranscription', payload);
        const { message, uuid, callContentID } = payload;
        if (!message) {
          return state;
        }
        console.log('updateLiveCallTranscription data.call_uuid', message, uuid);
        const { generated_text } = message;
        const res_generated_text = JSON.parse(generated_text);
        const indexOfCalls = state.data.findIndex((call) => call?.data?.call_uuid === uuid);
        if (indexOfCalls > -1) {
          state.data[indexOfCalls] = {
            ...state.data[indexOfCalls],
            avg_sentiment: res_generated_text.sentiment ? res_generated_text.sentiment : state.data[indexOfCalls].avg_sentiment,
            avg_intent: res_generated_text.topic ? res_generated_text.topic : state.data[indexOfCalls].avg_intent
          };
        }
        if (Object.prototype.hasOwnProperty.call(state.transcript, uuid)) {
          const indexOfCallContent = state.transcript[uuid].findIndex((el) => el.id == callContentID);
          console.log('indexOfCallContent', indexOfCallContent);
          if (indexOfCallContent > -1) {
            state.transcript[uuid][indexOfCallContent] = {
              ...state.transcript[uuid][indexOfCallContent],
              intent: res_generated_text?.topic || state.transcript[uuid][indexOfCallContent]?.intent,
              sentiment: res_generated_text?.sentiment || state.transcript[uuid][indexOfCallContent]?.avg_sentiment,
              avg_sentiment: res_generated_text?.sentiment || state.transcript[uuid][indexOfCallContent]?.avg_sentiment
            };
          }
        } else {
          // state.transcript[uuid] = [message];
        }
      } else {
        console.error('updateLiveCallTranscriptionIntentOrSentiment');
      }
    }
  },

  extraReducers: {
    [getLiveCallsData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getLiveCallsData.fulfilled]: (state, action) => {
      console.log(action.payload, 'action.payload.live_call');
      state.status = 'idle';
      state.ui.loading = false;
      if (isEmpty(action.payload)) {
        state.data = null;
      } else {
        state.live_count = action.payload?.live_count;

        if (action.payload) state.data = Object.values(action?.payload);
      }
    },

    [getLiveCallsData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    // getDownloadReport

    [livecalltranscript.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [livecalltranscript.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;

      const { uuid } = action.payload;
      const { conversation } = action.payload.data;
      console.log('conversation', conversation);
      if (conversation) {
        state.transcript[uuid] = generateTranscriptionFromAPI(conversation);
      }
      // state.transcript = action.payload;
      // if (isEmpty(action.payload)) {
      //   state.data = null;
      // } else {
      //   state.live_count = action.payload.live_count;
      //   state.data = Object.values(action.payload.live_call);
      // }
    },

    [livecalltranscript.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    }
  }
});

const {
  resetState,
  setPageSize,
  setCurrentPage,
  updateLiveCall,
  showchat,
  setSelectedId,
  updateLiveCallTranscription,
  updateLiveCallIntent,
  updateLiveCallTranscriptionIntentOrSentiment
} = liveCallSlice.actions;

export default liveCallSlice.reducer;

export {
  getLiveCallsData,
  getLiveCallstate,
  resetState,
  setPageSize,
  setCurrentPage,
  showchat,
  setSelectedId,
  updateLiveCall,
  updateLiveCallTranscription,
  livecalltranscript,
  updateLiveCallIntent,
  updateLiveCallTranscriptionIntentOrSentiment
};

/*
 {
      type: 'call_data',
      call_status: 'In-Progress',
      data: {
        call_uuid: '1680171263.7798-83858915-2537-4ff9-9df4-375b135ce682',
        source_number: '5001',
        destination_number: '9852545256',
        call_dial_start_time: '2023-03-01 15:20:00',
        call_answered_time: '2023-03-01 14:16:00',
        direction: 'Outbound-agent'
      }
    }

*/
